import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { NamedLink, Logo, ExternalLink } from '../../components';
import css from './TopbarMobileMenu.module.css';
import { t } from '../../util/messages';

const TopbarMobileMenu = ({ config, onClose }) => (
  <nav
    id="mobile-menu"
    className={css.root}
    aria-label="Mobile navigation"
  >
    <div className={css.content}>
      <div className={css.actions}>
        <NamedLink className={css.home} name="LandingPage" aria-label="Gitribe home">
          <Logo
            format="desktop"
            width={150}
            className={css.sitelogo}
            alt={t('TopbarDesktop.logo')}
          />
        </NamedLink>
      </div>

      <div className={css.links}>
        <div className={css.linksCollection}>
          <NamedLink
            className={css.link}
            name="ServicesPage"
            title={t('Topbar.services')}
            onClick={onClose}
          >
            {t('Topbar.services')}
          </NamedLink>
          <NamedLink
            className={css.link}
            name="LandingPage"
            title={t('Topbar.clients')}
            to={{ hash: '#portfolio' }}
            onClick={onClose}
          >
            {t('Topbar.clients')}
          </NamedLink>
          <NamedLink
            className={css.link}
            name="LandingPage"
            title={t('Topbar.contactUs')}
            to={{ hash: '#contact-us' }}
            onClick={onClose}
          >
            {t('Topbar.contactUs')}
          </NamedLink>
          <ExternalLink
            className={css.link}
            title={t('Topbar.insights')}
            href="https://blog.gitribe.com"
          >
            {t('Topbar.insights')}
          </ExternalLink>
        </div>
      </div>

      {/* Pinned to the bottom of the drawer, within thumb reach. */}
      <div className={css.footerActions}>
        <NamedLink
          className={css.primaryAction}
          name="LandingPage"
          title={t('Topbar.startProject')}
          to={{ hash: '#contact-us' }}
          onClick={onClose}
        >
          {t('Topbar.startProject')}
        </NamedLink>
        <ExternalLink className={css.secondaryAction} title={t('Footer.phone')} href="tel:+923054000453">
          {t('Footer.phone')}
        </ExternalLink>
      </div>
    </div>
  </nav>
);

TopbarMobileMenu.propTypes = {
  config: PropTypes.object,
  onClose: PropTypes.func,
};

export default TopbarMobileMenu;
